const fishHandles = new Set(['anchovy','black-pomfert','cat-fish','cobia','emperor-fish','giant-trevally','grouped-brown','indian-mahi-mahi','kingfish','milk-fish','needle-fish','parrot-fish','pearlspot','pickhandle-baracuda','pink-peach','red-grouper','sardine','scad-fish','squid','sword-fish','thredfin-bream','tongue-sole','tuna','white-pomfret','yellow-snapper']);
let submitting = false;

document.addEventListener('click', async (event) => {
  if (!(event.target instanceof Element)) return;
  const button = event.target.closest('a,button,input[type="submit"]');
  if (!button || (button.textContent || button.value || '').trim().replace(/\s+/g,' ').toLowerCase() !== 'order now') return;

  const card = button.closest('product-card, .product-card, [data-product-card]');
  if (!card) return;
  const productLink = card.querySelector('a[href*="/products/"]');
  if (!productLink) return;
  const productUrl = new URL(productLink.href, location.origin);
  const handle = productUrl.pathname.split('/').filter(Boolean).pop();
  if (!fishHandles.has(handle)) return;

  const formComponent = button.closest('product-form-component') || card.querySelector('product-form-component');
  const form = button.form || formComponent?.querySelector('form') || card.querySelector('form[action*="/cart/add"]');
  if (!form || submitting) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }

  const data = new FormData(form);
  const variantId = String(data.get('id') || formComponent?.querySelector('[name="id"]')?.value || '');
  const quantity = Math.max(1, Number(data.get('quantity') || formComponent?.dataset.quantityDefault || 1));
  if (!variantId) return;

  event.preventDefault();
  event.stopImmediatePropagation();
  submitting = true;
  if (button instanceof HTMLButtonElement || button instanceof HTMLInputElement) button.disabled = true;

  // The card's selection may sit outside the form, so read it directly first.
  const selectedPreparation = card.querySelector('input[type="radio"][name="properties[Fish Preparation]"]:checked, input[type="radio"][name*="Fish Preparation"]:checked, input[type="radio"][value="Clean and cut my fish"]:checked');
  const preparation = String(selectedPreparation?.value || data.get('properties[Fish Preparation]') || 'No cutting');
  const properties = {};
  for (const [key, value] of data.entries()) {
    const match = key.match(/^properties\[(.+)\]$/);
    if (match && !match[1].startsWith('_')) properties[match[1]] = value;
  }
  if (selectedPreparation?.name) {
    const propertyMatch = selectedPreparation.name.match(/^properties\\[(.+)\\]$/);
    if (propertyMatch) properties[propertyMatch[1]] = preparation;
  }
  properties['Fish Preparation'] = preparation;

  const items = [{ id: Number(variantId), quantity, properties }];
  if (preparation === 'Clean and cut my fish') {
    const serviceId = Number(formComponent?.dataset.cuttingServiceVariantId || document.querySelector('script[data-fish-cutting-sync]')?.dataset.serviceVariantId || 67563033395358);
    const groupId = 'fish-cutting-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
    properties._fish_cutting_group = groupId;
    items[0].properties = properties;
    items.push({
      id: serviceId,
      quantity,
      properties: {
        _fish_cutting_group: groupId,
        'Fish preparation for': formComponent?.dataset.productTitle || card.querySelector('.product-card__link')?.getAttribute('aria-label') || 'Fish'
      }
    });
  }

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items })
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || 'Could not add the fish to cart.');
    location.assign('/checkout');
  } catch (error) {
    submitting = false;
    if (button instanceof HTMLButtonElement || button instanceof HTMLInputElement) button.disabled = false;
    console.error('Fish order failed:', error);
    alert(error?.message || 'Sorry, this fish could not be added. Please try again.');
  }
}, true);